import RestCreate from 'containers/rest/Create';
import { formatTextToSlug } from 'utils/formattedString';
import LocationForm from '../components/LocationForm';

const breadcrumbs = [
  {
    title: 'common.page.settings',
    href: '/settings',
  },
  {
    title: 'common.page.locations',
    href: '/settings/warehouse-locations',
  },
  {
    title: 'common.page.create',
  },
];

export default function LocationCreate() {
  return (
    <RestCreate
      model="locations"
      breadcrumbs={breadcrumbs}
      customPathAfterSubmit="settings/warehouse-locations"
      hasSelectFilter={false}
      customUrlBack="/settings/warehouse-locations"
      apiOptions={{
        isShowSuccessNoti: true,
      }}
      formatOnSubmit={(data) => ({
        ...data,
        id: formatTextToSlug(data?.code?.trim()),
        lat: parseFloat(data?.lat),
        long: parseFloat(data?.long),
      })}
    >
      <LocationForm isCreate />
    </RestCreate>
  );
}
